module.exports = __webpack_public_path__ + "static/jinx_320w_q50-e51dae9222e30f672c4e8b693e56b6ba.webp";